// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1WiuT","dragIcon":"SortableItem_dragIcon__1aXKE","disabled":"SortableItem_disabled__27h2z"};